import { render, staticRenderFns } from "./CommentModal.vue?vue&type=template&id=7c3ac8bc"
import script from "./CommentModal.vue?vue&type=script&lang=js"
export * from "./CommentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports